import Dinero from "dinero.js";
import { createPrice } from "./createPrice";

export const sumPrices = (prices: Dinero.Dinero[]) =>
  prices.reduce((priceAcc, price) => priceAcc.add(price), createPrice(0));
